(function () {
  /* Buscador integrado: resultados en un desplegable debajo de la casilla, sin modal */
  var POP = ['morral', 'lonchera', 'tote', 'puffy', 'estuche'];
  var ICON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21"/></svg>';
  var desk = window.matchMedia('(min-width: 750px)');
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function price(p) { var n = parseFloat(p); if (isNaN(n)) return ''; return 'Ref. ' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function allUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }

  function build(mod) {
    var f = document.createElement('form');
    f.className = 'vb-sx vb-sx--' + mod;
    f.action = '/search';
    f.method = 'get';
    f.setAttribute('role', 'search');
    f.innerHTML = '<input type="hidden" name="type" value="product"><input type="hidden" name="options[prefix]" value="last">' +
      '<input class="vb-sx__in" type="search" name="q" placeholder="¿Buscas algo?" autocomplete="off" aria-label="Buscar">' +
      '<button class="vb-sx__go" type="submit" aria-label="Buscar">' + ICON + '</button><div class="vb-sx__dd" hidden></div>';
    var inp = f.querySelector('.vb-sx__in'), dd = f.querySelector('.vb-sx__dd'), t = null, last = '';
    function show(html) { dd.innerHTML = html; dd.hidden = false; f.classList.add('is-open'); }
    function hide() { dd.hidden = true; f.classList.remove('is-open'); }
    function popular() {
      var list = [].map.call(document.querySelectorAll('.custom_search__inner a'), function (a) { return a.textContent.trim(); }).filter(Boolean);
      if (!list.length) list = POP;
      show('<p class="vb-sx__h">Búsquedas populares</p><div class="vb-sx__pop">' + list.map(function (p) {
        return '<a href="' + allUrl(p) + '">' + esc(p) + '</a>';
      }).join('') + '</div>');
    }
    function search() {
      var q = inp.value.trim();
      if (q.length < 2) { last = ''; popular(); return; }
      if (q === last) return;
      last = q;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== inp.value.trim()) return;
          var res = (d.resources && d.resources.results) || {};
          var ps = res.products || [], cs = res.collections || [];
          var h = '';
          if (cs.length) h += '<div class="vb-sx__cols">' + cs.slice(0, 4).map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
          if (ps.length) {
            h += ps.map(function (p) {
              var u = p.image || (p.featured_image && p.featured_image.url) || '';
              return '<a class="vb-sx__p" href="' + esc(p.url) + '">' + (u ? '<img src="' + esc(img(u, 120)) + '" alt="" loading="lazy">' : '<span class="vb-sx__ph"></span>') +
                '<span class="vb-sx__t">' + esc(p.title) + '</span><span class="vb-sx__pr">' + price(p.price) + '</span></a>';
            }).join('');
            h += '<a class="vb-sx__all" href="' + allUrl(q) + '">Ver todos los resultados →</a>';
          } else if (!cs.length) {
            h += '<p class="vb-sx__none">No encontramos nada para “' + esc(q) + '”</p>';
          }
          show(h);
        }).catch(function () {});
    }
    inp.addEventListener('input', function () { clearTimeout(t); t = setTimeout(search, 180); });
    inp.addEventListener('focus', function () { last = ''; search(); });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); inp.blur(); if (mod === 'm') closeBar(); } });
    f.addEventListener('submit', function (e) { if (!inp.value.trim()) e.preventDefault(); });
    document.addEventListener('click', function (e) { if (!f.contains(e.target)) hide(); });
    f._hide = hide;
    return f;
  }

  /* Computadora: casilla real en el header */
  function mountDesk() {
    var dm = document.querySelector('.header details-modal.header__search');
    if (!dm || dm.previousElementSibling && dm.previousElementSibling.classList.contains('vb-sx--d')) return;
    dm.insertAdjacentElement('beforebegin', build('d'));
    document.documentElement.classList.add('vb-sx-on');
  }

  /* Celular: barra delgada debajo del header al tocar la lupa */
  var bar = null;
  function headerBottom() {
    var h = document.querySelector('.section-header, sticky-header, .header-wrapper') || document.querySelector('.header');
    var b = h ? h.getBoundingClientRect().bottom : 60;
    return Math.max(0, Math.round(b));
  }
  function openBar() {
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'vb-sxbar';
      bar.appendChild(build('m'));
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'vb-sxbar__x';
      x.setAttribute('aria-label', 'Cerrar');
      x.innerHTML = '&times;';
      x.addEventListener('click', closeBar);
      bar.appendChild(x);
      document.body.appendChild(bar);
    }
    bar.style.top = headerBottom() + 'px';
    bar.classList.add('is-open');
    setTimeout(function () { bar.querySelector('.vb-sx__in').focus(); }, 30);
  }
  function closeBar() { if (bar) { bar.classList.remove('is-open'); bar.querySelector('form')._hide(); } }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.header details-modal.header__search summary');
    if (!s || desk.matches) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (bar && bar.classList.contains('is-open')) closeBar(); else openBar();
  }, true);
  window.addEventListener('scroll', function () { if (bar && bar.classList.contains('is-open')) bar.style.top = headerBottom() + 'px'; }, { passive: true });

  /* Pagina de resultados: titulo pequeno */
  function resultsPage() {
    if (!document.body.classList.contains('template-search')) return;
    var h = document.querySelector('.template-search__header h1');
    var q = new URLSearchParams(location.search).get('q') || '';
    if (h && q && !h.dataset.vb) {
      h.dataset.vb = 1;
      var n = (document.title.match(/(\d+)\s+resultado/) || [])[1];
      h.textContent = (n ? n + ' resultado' + (n === '1' ? '' : 's') + ' para ' : 'Resultados para ') + '“' + q + '”';
    }
  }

  function run() { mountDesk(); resultsPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(run, 800);
})();
